export class ChangeCharacterFromIssue {
  ChangeAmpersand(issueId: string): string {
    return issueId.toLocaleUpperCase().replace(/&/g, 'Ñ');
  }

  ChangeToAmpersand(issueId: string): string {
    return issueId.replace(/Ñ/gi, '&');
  }
}
